import {createSelector} from 'reselect'

export const selectTeamAssignmentsPanel = state => state.userManagement.createTeamAssignmentsPanel

export const isPanelOpened = createSelector(
    selectTeamAssignmentsPanel,
    panel => panel.show
)



// WEBPACK FOOTER //
// ./web/js/panels/user/createTeamAssignmentsPanel/selectors.js